import { render, staticRenderFns } from "./stocknumberselector.vue?vue&type=template&id=4ef08ea0"
import script from "./stocknumberselector.vue?vue&type=script&lang=js"
export * from "./stocknumberselector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports